/**
 * Promotion (owner decision, 27 Oct 2026): the first 100 direct buyers pay RM49, direct buyers after that RM59 (list price RM89). Any licence holder can be an
 * affiliate: they set the selling price (RM69–RM89) and the owner always nets RM49, so commission = price paid − RM49.
 *
 * Earlier rules (owner decision, 11 Oct 2026), kept for history: All MYR amounts are integer sen (no floating-point money).
 *
 * Pricing:
 *  - Buyers 1–100 buying DIRECT from JomCerdik  → RM69 (Early Bird 1)
 *  - Buyers 101–200 buying DIRECT             → RM79 (Early Bird 2)
 *  - Everyone after that, and anyone buying through an affiliate link → RM89
 * Affiliate programme: open only to the 200 early buyers (owner may open it later via a promotion).
 * Commission = RM89 − price the affiliate paid → RM20 for RM69 buyers, RM10 for RM79 buyers.
 */
export const PRICE_SEN = {
  EARLY_BIRD_1: 4900,
  /** Direct buyers after the first 100 pay this. */
  DIRECT: 5900,
  /** List ("real") price; also the top of the affiliate selling range. */
  STANDARD: 8900,
} as const;

export const EARLY_TIERS = [
  { tier: "early_bird_1", fromSlot: 1, toSlot: 100, priceSen: PRICE_SEN.EARLY_BIRD_1 },
] as const;

/** Total early slots across both tiers. */
export const EARLY_SLOT_COUNT = 100;

export const AFFILIATE = {
  OPEN_TO_TIERS: ["early_bird_1", "early_bird_2", "standard"] as readonly string[],
  OWNER_NET_SEN: 4900, // the owner nets RM49 on every affiliate sale
  SELL_MIN_SEN: 6900, // an affiliate may sell from RM69 …
  SELL_MAX_SEN: 8900, // … to RM89
  HOLD_DAYS: 14,
  MIN_PAYOUT_SEN: 10000, // RM100 (owner decision 21 Oct 2026)
  PAYOUT_CYCLE_DAYS: 14, // payouts are processed by hand every 2 weeks
} as const;

/** Free trial of JomBelajar for signed-in users without a licence: one per account, never restarts. */
export const TRIAL = { MINUTES: 5 } as const;

export const AI_QUOTA = {
  MONTHLY_GENERATIONS: 20,
  TIMEZONE: "Asia/Kuala_Lumpur",
} as const;

/** AI credits (owner decision 12 Oct 2026): 1 credit = 1 generated paper. Authoritative values live in
 *  product_settings 'ai_credits'; these mirror them for page copy. */
export const AI_CREDITS = {
  LICENCE_GRANT: 30, // papers with every lifetime licence
  TOPUP_PRICE_SEN: 5000, // RM50 …
  TOPUP_CREDITS: 60, // … adds 60 papers
  TOPUP_AFFILIATE_SEN: 1000, // RM10 to the referring affiliate
} as const;

export const INVITATION_TTL_HOURS = 72;

export type PriceTier = "early_bird_1" | "early_bird_2" | "standard";
